module.exports = __webpack_public_path__ + "static/media/view student enquiry and staff enquiry.be721e2e.svg";